(function ($) {
  const delay = 100;

  $(function () {
    const $newsInsightsBlock = $(".c-news-block__container--post");
    const $twoColLeft = $(".c-two-col-block .gh-aos--fade-left");
    const $twoColRight = $(".c-two-col-block .gh-aos--fade-right");

    const fadeBlocks = [
      ".container--services",
      ".c-intro-block",
      ".testimonial-block",
      ".c-leadership-block",
    ];
    $.each(fadeBlocks, function (i, className) {
      $(className)
        .find(".gh-aos--fade-up")
        .each(function (index) {
          const row = $(this);
          row.attr("data-aos", "fade-up");
          row.attr("data-aos-delay", delay * index);
        });
    });

    $newsInsightsBlock.each(function (index) {
      const row = $(this);
      row.attr("data-aos", "fade-up");
      row.attr("data-aos-delay", delay * index);
    });

    $twoColLeft.each(function (index) {
      const row = $(this);
      row.attr("data-aos", "fade-left");
      row.attr("data-aos-delay", delay * index);
    });
    $twoColRight.each(function (index) {
      const row = $(this);
      row.attr("data-aos", "fade-right");
      row.attr("data-aos-delay", delay * index);
    });

    AOS.init({
      startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
      easing: "ease-out", // default easing for AOS animations
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "center-center", // defines which position of the element regarding to window should trigger the animation
    });
  });
})(jQuery);
